import { Component, Input, Output, EventEmitter } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-lower-bid-confirmation-modal',
  standalone: true,
  imports: [CommonModule],
  template: `
    <div
      class="modal-overlay"
      [class.active]="isActive">
      <div class="modal">
        <button class="close-modal" (click)="onCancel()">x</button>
        
        <div class="punk-info">
          <h1 i18n style="font-size: 2.3rem; font-weight: 700; margin-bottom: 2rem;">⚠️ Not the Highest Bid</h1>
          <p i18n>
            You are about to accept a bid that is <strong>not the highest offer</strong> available.
          </p>
          <p i18n>
            Are you sure you want to proceed? You may be leaving money on the table.
          </p>
        </div>

        <div class="form-actions">
          <button i18n class="cancel" (click)="onCancel()">Cancel</button>
          <button i18n class="submit" (click)="onConfirm()">Confirm Acceptance</button>
        </div>
      </div>
    </div>
  `,
  styles: []
})
export class LowerBidConfirmationModalComponent {
  @Input() isActive: boolean = false;
  @Output() confirmed = new EventEmitter<void>();
  @Output() cancelled = new EventEmitter<void>();

  onConfirm(): void {
    this.confirmed.emit();
  }

  onCancel(): void {
    this.cancelled.emit();
  }
}
